// // import React from 'react';
// // import { Calendar, Download } from 'lucide-react';

// // const SectionHeader = ({
// //   title,
// //   subtitle,
// //   dateFilter,
// //   onDateChange,
// //   onDownload,
// //   dateOptions
// // }) => {
// //   return (
// //     <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
// //       <div>
// //         <h3 className="text-lg font-semibold text-foreground mb-1">
// //           {title}
// //         </h3>
// //         <p className="text-sm text-muted-foreground">
// //           {subtitle}
// //         </p>
// //       </div>

// //       <div className="flex items-center gap-3">
// //         {/* Download */}
// //         <button
// //           onClick={onDownload}
// //           className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all text-sm font-medium shadow-sm"
// //         >
// //           <Download className="w-4 h-4" />
// //           Download
// //         </button>

// //         {/* Date Filter */}
// //         <div className="flex items-center gap-2">
// //           <Calendar className="w-4 h-4 text-muted-foreground" />
// //           <select
// //             value={dateFilter}
// //             onChange={(e) => onDateChange(e.target.value)}
// //             className="appearance-none bg-background border border-border rounded-lg px-4 py-2 text-sm font-medium hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
// //           >
// //             {dateOptions.map((option) => (
// //               <option key={option} value={option}>
// //                 {option}
// //               </option>
// //             ))}
// //           </select>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default SectionHeader;

// import React from 'react';
// import { Download } from 'lucide-react';
// import DateFilterWithRange from './DateFilterWithRange';

// const SectionHeader = ({
//   title,
//   subtitle,
//   dateFilter,
//   onDateChange,
//   onDownload
// }) => {
//   return (
//     <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
//       <div>
//         <h3 className="text-lg font-semibold text-foreground mb-1">
//           {title}
//         </h3>
//         <p className="text-sm text-muted-foreground">
//           {subtitle}
//         </p>
//       </div>

//       <div className="flex items-start gap-3">
//         <button
//           onClick={onDownload}
//           className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 text-sm font-medium"
//         >
//           <Download className="w-4 h-4" />
//           Download
//         </button>

//         <DateFilterWithRange
//           value={dateFilter}
//           onChange={onDateChange}
//         />
//       </div>
//     </div>
//   );
// };

// export default SectionHeader;

import React from 'react';
import { Calendar, Download } from 'lucide-react';

const SectionHeader = ({
  title,
  subtitle,
  dateFilter,
  onDateChange,
  onDownload,
  dateOptions
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-1">
          {title}
        </h3>
        <p className="text-sm text-muted-foreground">
          {subtitle}
        </p>
      </div>

      <div className="flex items-center gap-3">
        {/* Download */}
        <button
          onClick={onDownload}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 text-sm font-medium"
        >
          <Download className="w-4 h-4" />
          Download
        </button>

        {/* Date dropdown */}
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4 text-muted-foreground" />
          <select
            value={dateFilter}
            onChange={(e) => onDateChange(e.target.value)}
            className="appearance-none bg-background border border-border rounded-lg px-4 py-2 text-sm font-medium hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
          >
            {dateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;


